import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

const spin = keyframes`
    to { transform: rotate(360deg); }
`;

export const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 8px 0;
    min-width: 480px;
`;

export const Subtitle = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.greyscale.gray50};
    font-size: 13px;
`;

export const ReadonlyTitle = styled.div`
    padding: 10px 12px;
    background: ${({ theme }) => theme.colors.greyscale.gray2_5};
    border: 1px solid ${({ theme }) => theme.colors.greyscale.gray15};
    border-radius: 6px;
    color: ${({ theme }) => theme.colors.greyscale.gray50};
    font-size: 13px;
    font-style: italic;
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const FieldLabel = styled.label`
    font-weight: 600;
    color: #111827;
    font-size: 13px;
`;

export const RequiredAsterisk = styled.span`
    color: #dc2626;
    margin-left: 4px;
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-end;
`;

export const ErrorText = styled.div`
    color: #dc2626;
    font-size: 12px;
`;

export const DropZone = styled.div<{ isDragging?: boolean; hasError?: boolean }>`
    position: relative;
    border: 2px dashed
        ${({ theme, hasError }) =>
            hasError ? '#dc2626' : theme.colors.greyscale.gray15};
    border-radius: ${rem(8)};
    padding: ${rem(28)} ${rem(20)};
    text-align: center;
    background: ${({ theme, isDragging }) =>
        isDragging ? theme.colors.primary.actionHover : theme.colors.greyscale.gray2_5};
    cursor: pointer;
    transition:
        border-color 0.15s,
        background 0.15s;

    &:hover {
        border-color: ${({ theme }) => theme.colors.primary.actionDefault};
    }
`;

export const DropZoneText = styled.p`
    font-size: ${rem(14)};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.greyscale.gray50};
    margin: ${rem(8)} 0 ${rem(4)};
`;

export const DropZoneSubText = styled.p`
    font-size: ${rem(12)};
    color: ${({ theme }) => theme.colors.greyscale.gray50};
    margin: 0;
`;

export const UploadOverlay = styled.div`
    position: absolute;
    inset: 0;
    border-radius: ${rem(8)};
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Spinner = styled.div`
    width: ${rem(28)};
    height: ${rem(28)};
    border: 3px solid ${({ theme }) => theme.colors.greyscale.gray15};
    border-top-color: ${({ theme }) => theme.colors.primary.actionDefault};
    border-radius: 50%;
    animation: ${spin} 0.7s linear infinite;
`;

export const FileList = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(10)};
    margin-top: ${rem(14)};
`;

export const FileRow = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: ${rem(12)};
    background: ${({ theme }) => theme.colors.greyscale.gray2_5};
    border: 1px solid ${({ theme }) => theme.colors.greyscale.gray15};
    border-radius: ${rem(8)};
    padding: ${rem(10)} ${rem(14)};
`;

export const FileName = styled.span`
    font-size: ${rem(13)};
    color: #111827;
    width: fit-content;
    max-width: 100%;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const DeleteButton = styled.button`
    flex-shrink: 0;
    width: ${rem(32)};
    height: ${rem(32)};
    border: none;
    background: none;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.greyscale.gray50};
    font-size: ${rem(16)};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${rem(4)};

    &:hover:not(:disabled) {
        color: ${({ theme }) => theme.colors.semantic.error50};
        background: ${({ theme }) => theme.colors.semantic.error10};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;

export const HiddenFileInput = styled.input`
    display: none;
`;
